/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
import { useContext } from 'react'
import { SidebarContext } from '../state/context'

export const useSidebar = () => useContext(SidebarContext)
